





































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { AddMemberRequest, ApiRequest } from '../../types/request';
import { validationMixin } from 'vuelidate';
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { MedTransGoConstants } from '../../util/constants';
import { ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import { OrgLocation, RxProvider } from '../../types/entity';
import { MemberProfile } from '../../types/response';
declare var google: any;


@Component({
    mixins: [validationMixin],
    data() {
        return {
            fullName: '',
            email: '',
            phone: '',
            address: {
                fullAddress: '',
                city: '',
                state: '',
                zip: '',
                landmark: '',
            },
            businessCloseTime: '',
        };
    },
    validations() {
    const validations = {
        fullName: {
            required,
        },
        email: {
            email,
        },
        phone: {
            regex: (phone: any) =>  MedTransGoConstants.PHONE_REGX.test(phone),
        },
        address: {
            fullAddress: {
                required,
            },
            state: {
                required,
            },
            city: {
                required,
            },
            zip: {
                required,
            },
        },
    };
    if (this.$data.phone === '') {
        delete validations.phone.regex;
    }
    return validations;
    },
})
export default class AddRxProviderModal extends Vue {
    private show = true;
    private providerGoogleAddress: any;

    public mounted() {
        this.getGoogleAddress();
    }

    private async getGoogleAddress() {
        this.$root.$on('bv::modal::shown', (bvEvent: any, modalId: any) => {
            this.providerGoogleAddress = new google.maps.places.Autocomplete(
                document.getElementById('providerAddress1'), {
                types: ['geocode'],
            },
            );
            this.providerGoogleAddress.addListener('place_changed', () => {
                this.$data.address = MapUtils.parseGoogleAddress(
                    this.providerGoogleAddress,
                );
            });
        });
    }

    private async addRxProvider() {
        const iHttpService = ObjectFactory.getHttpService();
        const addRxProviderRequest: RxProvider = {
            fullname: this.$data.fullName,
            email: this.$data.email,
            phone: this.$data.phone,
            address: this.$data.address,
            businessCloseTime: this.$data.businessCloseTime,
        };
        const response = await ObjectFactory.getRxProviderService().addRxProvider(this.$store.state.serverUrl,
        addRxProviderRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_ADD_RX_PROVIDER'),
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        }
    }

    private async phoneNumberMask() {
        const replaceInput = this.$data.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.$data.phone = !replaceInput[2] ? replaceInput[1] :
        replaceInput[1] + '-' + replaceInput[2] + (replaceInput[3] ? '-' + replaceInput[3] : '');
    }


    private close() {
        this.$emit('close');
    }
}
